<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path
      d="M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'close',
}
</script>
